import { createSlice } from '@reduxjs/toolkit';

const announcementSlice = createSlice({
  name: 'announcement',
  initialState: {
    uploadProgress: null,
    uploadStarted: false,
    isOutlet:false
  },
  reducers: {
    setPingsAttachmentUploadProgress: (state, action) => {
      const { progress, uploadStarted } = action.payload;
      state.uploadStarted = uploadStarted;
      state.uploadProgress = progress;
    },
    toggleOutlet:(state,action) => {
      state.isOutlet = action.payload
    }
  },
});

export const { setPingsAttachmentUploadProgress,toggleOutlet } = announcementSlice.actions;

export const selectPingsUploadProgress = state => state.announcement.uploadProgress;
export const selectPingsUploadStarted = state => state.announcement.uploadStarted;
export const selectIsOutlet = state => state.announcement.isOutlet;

export default announcementSlice.reducer;
